export default __webpack_public_path__ + "static/media/hop03.b0dc8291.png";